import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import ComponentLayout from "../Layouts/ComponentLayout.tsx";
import React from "react";
import RoleEditor from "./RoleEditor.tsx";
import { PiArrowBendUpLeft } from "react-icons/pi";
import { AuditObjectTypes } from "../../_core/_model.ts";
import { Spinner } from "react-bootstrap";
import { FaCheckCircle, FaTimes, FaUsers } from "react-icons/fa";
import TooltipButton from "../Tools/TooltipButton.tsx";
import { AnimatePresence, motion } from "framer-motion";
import RoleGroupUsers from "../Roles/RoleGroupUsers.tsx";

export function RolleEditorFull() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const roleRef = useRef<any>(null);
    const [progress, setProgress] = useState<string | null>(null);
    const [showDrawer, setShowDrawer] = useState(false);
    const [canSave, setCanSave] = useState<boolean>(false);

    const getInstace = () => {
        let rId = searchParams.get("roleId");
        return rId != null ? parseInt(rId.toString()) : 0
    }

    return (
        <ComponentLayout
            exButtons={<>
                {
                    (progress == null) ?
                        (canSave ?
                            <button className="btn btn-success py-2 px-4 d-flex flex-row align-items-center gap-1 text-nowrap" onClick={() => { roleRef.current.SaveRole(setProgress) }}>
                                <FaCheckCircle />Save & Close</button>
                            :
                            <button className="btn bg-secondary text-white border py-2 px-4 d-flex flex-row align-items-center gap-1 text-nowrap j_r_save" style={{ opacity: "0.5", cursor: "not-allowed" }}> <FaCheckCircle />Save & Close</button>) :
                        <button className="btn btn-warning py-2 px-4">
                            <div className='d-flex flex-row align-items-center gap-2 text-nowrap'>
                                <Spinner animation="border" size='sm' /> <span>Save in progress</span>
                            </div>
                        </button>
                }
                {getInstace() > 0 && (
                    <TooltipButton title="View Associated Users">
                        <button className="btn btn-outline-primary d-flex align-items-center gap-2 px-2 j_r_assU" onClick={() => setShowDrawer(true)}>
                            <FaUsers size={20} />
                        </button>
                    </TooltipButton>
                )}
            </>}
            instanceId={getInstace()} objectType={AuditObjectTypes.Role} title={
                <span className="d-flex flex-row align-items-center gap-2">
                    <div className='fw-normal'>
                        <div className=''>Role Details</div>
                    </div>
                    <span className='fs-3 px-2 mx-2 fw-normal' style={{ opacity: "0.2" }}>|</span>
                    <button className='btn px-0' onClick={() => {
                        navigate("/roles")
                    }}>
                        <div className='d-flex flex-row align-items-center gap-1 fw-500 j_r_bBtn'>
                            <PiArrowBendUpLeft size={16} />
                            Back to all Roles
                        </div>
                    </button>
                </span>} bodyHeight={300} subHeader={undefined} cBody={
                    <div className="px-4 h-100 overflow-auto">
                        <RoleEditor canSaveCall={setCanSave} ref={roleRef} {...{
                            roleId: searchParams.get("roleId"), onClose: () => {
                                navigate("/roles");
                            }, preFills: undefined
                        }} />
                        <AnimatePresence>
                            {showDrawer && (
                                <motion.div
                                    initial={{ x: '100%' }}
                                    animate={{ x: 0 }}
                                    exit={{ x: '100%' }}
                                    transition={{ duration: 0.3 }}
                                    className="position-fixed top-0 end-0 bg-theme-card border-start shadow p-3"
                                    style={{ width: '400px', height: '100vh', zIndex: 1050 }}
                                >
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <h5 className="mb-0">Associated Users</h5>
                                        <button className="btn btn-sm btn-outline-secondary" onClick={() => setShowDrawer(false)}>
                                            <FaTimes />
                                        </button>
                                    </div>
                                    <div className='d-flex w-100' style={{ maxHeight: '90vh', overflowY: 'auto' }}>
                                        {
                                            getInstace() != 0 &&
                                            <RoleGroupUsers roleId={getInstace()} roleGroupId={0} />
                                        }
                                    </div>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>
                } />
    );
}

export default RolleEditorFull;